import Vue from "vue";
import store from "@/store";
import axios from "axios";
const axiosIns = axios.create({
  // Filled at startup from public/config.json (see loadApiConfig); the cached value is only a fallback.
  baseURL: localStorage.getItem("link") || "",
  // Without a limit a request on a weak mobile network can hang forever with the spinner on.
  timeout: 30000,
  mode: "cors",
  cache: "no-cache",
  credentials: "same-origin",
});

// Reads the API address ("link") from config.json, which is copied as-is to the build output,
// so the server address can be changed after deployment without rebuilding.
export function loadApiConfig() {
  return fetch(`${process.env.BASE_URL}config.json?ts=${Date.now()}`)
    .then((response) => {
      if (!response.ok) throw new Error(`config.json: HTTP ${response.status}`);
      return response.json();
    })
    .then((data) => {
      if (!data.link) throw new Error('config.json has no "link" value');
      axiosIns.defaults.baseURL = data.link;
      localStorage.setItem("link", data.link);
    })
    .catch((error) => {
      console.error("Error loading config.json:", error);
    });
}

/** Turns any failed request into a message the user can act on (never empty). */
export function describeError(error) {
  if (!error.response) {
    if (error.code === "ECONNABORTED") return "انتهت مهلة الاتصال بالخادم، يرجى التحقق من الإنترنت والمحاولة مجددا";
    // No response at all: wrong "link" in config.json, server down, no internet or CORS.
    return "تعذر الاتصال بالخادم، يرجى التحقق من الإنترنت والمحاولة مجددا";
  }
  const { status, data } = error.response;
  const serverMessage =
    (data && data.error && (data.error.message || (typeof data.error == "string" && data.error))) ||
    (data && data.message) ||
    (typeof data == "string" && data.length < 200 && data);
  return serverMessage ? `${serverMessage} (${status})` : `فشلت العملية، خطأ من الخادم (${status})`;
}

axiosIns.interceptors.response.use(
  function(response) {
    if (response.config.method != "get") {
      // Closed first so a message still on screen restarts its 5 s instead of vanishing early or looking like nothing happened.
      store.commit("UPDATE_SNACKBAR", false);
      Vue.nextTick(() => {
        store.commit("UPDATE_SNACKBAR_MESSAGE", {
          message: "تمت العملية بنجاح",
          color: "success",
        });
      });
    }
    return response;
  },
  function(error) {
    console.error(error.config && error.config.url, error.response || error);
    store.commit("UPDATE_SNACKBAR", true);
    store.commit("UPDATE_SNACKBAR_MESSAGE", { message: describeError(error) });
    store.commit("setLoading", false);
    return Promise.reject(error);
  }
);
Vue.prototype.$http = axiosIns;
export default axiosIns;
